import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { CSuggestionCreateViewModel } from '../models/suggestion.models/suggestionCreateViewModel.model';


@Injectable()
export class SuggestionService {
    constructor(private http: HttpClient) {
        
    }

    CreateNew(viewModel: CSuggestionCreateViewModel) {
        return this.http.post(API_ServerAddress + 'api/Suggestions/NewSuggestion', viewModel);
    }

}